<template>
    <div class="d-flex flex-lg-row justify-content-center">
        <div class="price-card column d-flex flex-column">
            <div class="card card-subscription h-100">
                <div class="card__heading border-radius-top bg-navy pt-5 pb-3 text-center shape shape--top-large">
                    <div class="mb-2">
                        <p class="fs-12 text-wrap t-white lh-lg font-weight-normal">CHOOSE A PAYMENT PLAN</p>
                        <p class="fs-12 text-wrap t-blue-pale lh-lg font-weight-normal">Pay yearly and get 2 months free!</p>
                    </div>
                    <div class="switch">
                        <div class="slider d-flex justify-content-around align-items-center">
                            <div v-for="type in subscriptionTypes"
                                 class="radio-div position-relative align-items-center fs-12 align-middle text-uppercase font-weight-bold"
                            >
                                <input
                                    type="radio"
                                    class="input-radio"
                                    :id="type.value"
                                    :value="type.value"
                                    v-model="form.subscription_type"
                                >
                                <label class="radio"
                                       :for="type.value"
                                >
                                <span class="fs-12 align-middle text-uppercase font-weight-bold"
                                      :class="{'radio-active': type.value === form.subscription_type}">{{type.label}}
                                </span>
                                <span class="radiomark"></span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="bg-orange old-price-badge mb-1 d-flex justify-content-center align-items-center">
                        <div class="old-price fs-12 text-wrap t-white lh-lg font-weight-semi-bold">
                            {{ subscriptionPrice }}
                        </div>
                    </div>
                    <div class="">
                        <div class="h1 t-white">
                            {{ subscriptionDiscount }}
                        </div>
                        <span class="h6 font-weight-normal t-disabled text-uppercase">
                            50% off for the first 12 months
                        </span>
                    </div>
                </div>
                <div class="card__content p-2 p-sm-3 pt-4">
                    <ul class="">
                        <li class="li-check font-weight-light lh-lg pb-1-5">
                            Upload your advertisement graphic to your CAT-UXO account.
                        </li>
                        <li class="li-check font-weight-light lh-lg pb-1-5">
                            Adjust or alter your graphic at any time for immediate live updates.
                        </li>
                        <li class="li-check font-weight-light lh-lg">
                            See your advertisement published on the CAT-UXO explosive hazard website.
                        </li>

                    </ul>
                </div>
                <div class="p-2 p-sm-3 mt-auto">
                    <a v-if="!loading"
                       @click="start"
                       :href="subscribeRoute"
                       class="btn w-100">
                        Start advertising today
                    </a>
                    <pulse-loader v-if="loading"
                                  :loading="true"
                                  :color="'#E57722'"
                                  class="d-flex justify-content-center align-items-center align-self-stretch flex-fill col-5 my-2 mh-100"
                                  :size="'20px'">
                    </pulse-loader>
                </div>
            </div>
        </div>
        <div class="stat-card p-50 d-flex flex-column justify-content-center">
            <div class="stats card w-70 h-100 border-radius-right bg-white">
                <div class="px-40 pt-40 text-left">
                    <div class="stats-numbers fs-52 font-weight-bold t-orange">{{ averagePageViews }}</div>
                    <h3 class="stats-text fs-12 text-uppercase">avg. page views per month</h3>
                </div>
                <div class="px-40 py-3 text-left">
                    <div class="stats-numbers fs-52 font-weight-bold t-orange">{{ averageUsers }}</div>
                    <h3 class="stats-text fs-12 text-uppercase">AVG. USERS PER MONTH</h3>
                </div>
                <div class="pb-40 px-40 text-left">
                    <div class="stats-numbers fs-52 font-weight-bold t-orange">{{ activeUsers }}</div>
                    <h3 class="stats-text fs-12 text-uppercase">ACTIVE USERS TODAY</h3>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import PulseLoader from "vue-spinner/src/PulseLoader";

    export default {
        name: 'CatUxoAdvertisement',
        components:{
            PulseLoader,
        },
        props: {
            averages: {
                type: Object,
                required: false
            },
            activeUsers: {
                type: String,
                required: false
            },
            plans: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                subscriptionTypes: [
                    {label: 'Per Month', value: 'monthly'},
                    {label: 'Per Year', value: 'yearly'},
                ],
                form: {
                    subscription_type: "monthly"
                },
                loading: false,
            }
        },
        computed: {
            averagePageViews() {
                return this.averages.page_views.avg;
            },
            averageUsers() {
                return this.averages.active_users.avg;
            },
            selectedSubscriptionType() {
                return this.form.subscription_type;
            },
            origin() {
                return window.location.origin;
            },
            subscribeRoute() {
                return `${this.origin}/advertisement/sign-up?plan=${this.form.subscription_type}`;
            },

            hasActiveUsers() {
                return this.activeUsers
            },

            monthlyPrice() {
                return this.plans.find(plan => plan.interval === 'monthly').price;
            },

            yearlyPrice() {
                return this.plans.find(plan => plan.interval === 'yearly').price;
            },

            subscriptionDiscount() {
                let price = this.form.subscription_type === 'monthly' ? this.monthlyPrice : this.yearlyPrice;
                let discount = ((price - 0.01) / 2).toFixed(2);

                return `£${discount}`;
            },

            subscriptionPrice() {
                return this.form.subscription_type === 'monthly' ? `£${this.monthlyPrice}` : `£${this.yearlyPrice}`;
            },
        },
        methods:{
            start(){
                this.loading= true
            }
        },
        watch: {
            activeUsers: {
                immediate: true,
                handler(count) {
                    console.log('Active Users', count);
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    .t-blue-pale{
        color: $c-blue-pale;
    }
    .px-40{
        padding: 0 40px 0 40px;
    }
    .pb-40{
        padding-bottom: 40px;
    }
    .pt-40{
        padding-top: 40px;
    }
    .pb-1-5{
        padding-bottom: 12px;
    }
    .p-75{
        padding: 0.75rem;
    }
    .p-50{
        padding: 0.5rem;
    }
    .fs-52{
        font-size: 52px;
    }
    .old-price-badge {
        width: 56px;
        height: 19px;
        border-radius: 6px;
        margin: 0 auto
    }
    .w-70{
        width: 270px;
    }
    .old-price{
        text-decoration: line-through;
    }
    .price-card{
        max-width: 425px;
    }
    .radio-active {
        color: $c-white;
        position: relative;
        z-index: 10;
    }
    .stats{
        background-image: url("../../img/graph.svg");
        background-repeat: no-repeat;
        background-size: 281px 177px;
        background-position: bottom -10px left -9px;
    }
    .shape--top-large:before{
        top: -50%;
    }
    .shape--top-large:after{
        height: 696px;
    }
    .switch {
        position: relative;
        display: inline-block;
        width: 193px;
        height: 33px;
        margin-bottom: 32px;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ffffff;
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 4px;
        z-index: 0;
    }
    label{
        color: #143642;
        z-index: 10000000;
    }
    input[type="radio"]:checked {
        position: initial;
    }

    input[type="radio"]:checked:before {
        position: absolute;
        content: "";
        height: calc(100% + 8px);
        top: -4px;
        left: -8px;
        width: calc(100% + 16px);
        background-color: #143642;
        border-radius: 4px;
        -webkit-transition: .4s;
        transition: .4s;
        z-index: 0;
    }
    input:focus{
        box-shadow: 0 0 1px #ffffff;
    }

    @media (max-width: 992px) {
        .advertisement {
            flex-direction: column;
        }
        .price-card{
            flex: 1;
            align-self: center;
        }
        .stat-card{
            align-self: center;
            margin-left: 0;
            width: 425px;
            padding: 0.5rem 1rem;
        }
        .stats {
            padding-bottom: 100px;
            width: 100% !important;
            background-size: 1538px 280px;
            background-position: bottom -1px left -559px;
        }
    }

    @media (max-width: 532px) {
        .price-card{
            padding: 0.5rem 0!important;
        }
        .stat-card{
            padding: 0.5rem 0!important;
        }
    }

    @media (max-width: 454px) {
        .stat-card{
            width: 100%;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/js/components/Advertisement.vue